import React from 'react';
import { RegionState } from '../../types';

interface RegionStateSelectorProps {
  title: string;
  states: RegionState[];
  selectedStates: string[];
  onStatesChange: (states: string[]) => void;
}

export default function RegionStateSelector({ 
  title, 
  states, 
  selectedStates, 
  onStatesChange 
}: RegionStateSelectorProps) {
  const allSelected = states.length > 0 && states.every(state => selectedStates.includes(state.id));

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      onStatesChange(states.map(state => state.id));
    } else {
      onStatesChange([]);
    }
  };

  return (
    <div className="mt-4 border-t border-gray-100 pt-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-gray-700">{title}</h3>
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            className="rounded border-gray-300 text-brand-primary focus:ring-brand-primary"
            checked={allSelected}
            onChange={(e) => handleSelectAll(e.target.checked)}
          />
          <span className="text-sm text-gray-700">Select All</span>
        </label>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {states.map((state) => (
          <label key={state.id} className="flex items-center space-x-2">
            <input
              type="checkbox"
              className="rounded border-gray-300 text-brand-primary focus:ring-brand-primary"
              checked={selectedStates.includes(state.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  onStatesChange([...selectedStates, state.id]);
                } else {
                  onStatesChange(selectedStates.filter(s => s !== state.id));
                }
              }}
            />
            <span className="text-sm text-gray-700">{state.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
}